import styled from "styled-components";
import { ArrowScroll } from "../../../services/visualLibraryService";
import { detailBackgroundStyled } from "../../../styles/shared-styles";
import { directions } from "../../../services/i18nService";

export const DetailPageStyled = styled.section`
  padding: 6% ${props => props.theme.baseLayoutPaddingBs}%;
  padding-${props => (props.theme.locale.dir === directions.RIGHT_TO_LEFT ? "left" : "right")}: 0; 
  ${detailBackgroundStyled.styles};
`;

export const ArrowScrollStyled = styled(ArrowScroll)`
  position: absolute;
  left: 50%;
  bottom: 5%;
  transform: translateX(-50%);
`;
